import { useState, useEffect } from "react";
import { DKLabel } from "deskera-ui-library";
import playButtonImg from "../../../assets/images/video_play_button.png";

const VideoSection = (props) => {
  const componentData = props.data.value;

  const [showVideo, setShowVideo] = useState(
    componentData.autoplayEnabled || !componentData.videoThumbnail
  );

  useEffect(() => {
    const shouldShowVideo =
      componentData.autoplayEnabled || !componentData.videoThumbnail;
    setShowVideo(shouldShowVideo);
  }, [componentData]);

  function getBackgroundStyles() {
    const bgStyles = {};

    if (componentData.videoThumbnail) {
      bgStyles.backgroundRepeat = "no-repeat";
      bgStyles.backgroundPositionX = "50%";
      bgStyles.backgroundPositionY = "50%";
      bgStyles.backgroundSize = "10%, cover";
      bgStyles.backgroundImage = `url(${playButtonImg}), url(${componentData.videoThumbnail})`;
      bgStyles.filter = "blur(0), blur(2px)";
    }

    return bgStyles;
  }

  function getThumbnail() {
    return (
      <div
        style={{
          width: "100%",
          paddingBottom: "56.25%",
          ...getBackgroundStyles(),
        }}
        onClick={() => setShowVideo(true)}
      ></div>
    );
  }

  function getModifiedLink() {
    const { videoURL } = componentData;

    /* In case it's a direct URL to youtube video, need to convert it to an embed link */
    const youtubeLinkRegex = new RegExp("youtube.com/watch\\?v=|youtu.be/");

    if (!youtubeLinkRegex.test(videoURL)) return videoURL;

    let newEmbedURL = videoURL.replace(youtubeLinkRegex, "youtube.com/embed/");

    /* to handle youtube watch links with additional query params other than videoId */
    newEmbedURL = newEmbedURL.replace(/(\?|&).*/, "");

    return newEmbedURL;
  }

  function getEmbedURL() {
    const { autoplayEnabled, videoThumbnail } = componentData;
    const shouldAutoplay =
      (!props.isEditing && autoplayEnabled) || videoThumbnail;

    let embedURL = getModifiedLink();

    return `${embedURL}${embedURL.includes("?") ? "&" : "?"}controls=1&start=0${
      shouldAutoplay ? "&autoplay=1" : ""
    }`;
  }

  function getVideoFrame() {
    return componentData.videoURL ? (
      <div
        style={{
          position: "relative",
          paddingBottom: "56.25%",
          pointerEvents: props.isEditing ? "none" : "initial",
        }}
      >
        <iframe
          title="video section"
          src={getEmbedURL()}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            border: "none",
          }}
          allow={"autoplay"}
        >
          <p>Your browser does not support iframes.</p>
        </iframe>
      </div>
    ) : (
      <div className="m-l">
        <DKLabel
          text="No video added"
          className="fw-m text-red text-align-center"
        />
        <DKLabel
          text="Please provide a video url from editor"
          className="text-gray mt-s text-align-center"
        />
      </div>
    );
  }

  return (
    <div
      style={{
        ...props.data.style,
        ...props.borderStyle,
      }}
    >
      {showVideo ? getVideoFrame() : getThumbnail()}
    </div>
  );
};

export default VideoSection;
